module.exports = __webpack_public_path__ + "static/media/parejas3.34843e38.jpg";